import React, { useState } from 'react';
import styled from 'styled-components';

const Select = styled.select`
  border: none;
  background: transparent;
  outline: none;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  color: #222;
  width: ${props => props.fixedWidth ? 'auto' : '100%'};
  min-width: ${props => props.fixedWidth ? '60px' : 'auto'};
  max-width: ${props => props.fixedWidth ? (props.isExpanded ? '400px' : '150px') : 'none'};
  cursor: pointer;
  transition: max-width 0.2s ease;
  
  option {
    padding: 8px;
  }
`;

const Filtro = ({ options, onSelect, label, fixedWidth, value }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    if (fixedWidth) {
      setIsExpanded(true);
    }
  };

  const handleBlur = () => {
    if (fixedWidth) {
      // Delay para permitir que o clique em uma opção seja processado
      setTimeout(() => {
        setIsExpanded(false);
      }, 150);
    }
  };

  const handleChange = (e) => {
    onSelect(e.target.value);
    if (fixedWidth) {
      setIsExpanded(false);
    }
  };

  return (
    <Select 
      fixedWidth={fixedWidth} 
      isExpanded={isExpanded}
      value={value ?? ''}
      onClick={handleClick}
      onBlur={handleBlur}
      onChange={handleChange}
    >
      <option value="">{label}</option>
      {options.map((option, index) => (
        <option key={index} value={option}>
          {option}
        </option>
      ))}
    </Select>
  );
};

export default Filtro;